import { FormControlLabel, FormLabel, Radio } from '@mui/material';
import styled from 'styled-components';

export const Container = styled.div``;

export const FormLabelStylized = styled(FormLabel)`
  && {
    color: #394760;
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
  }
`;

export const FormControlLabelStylized = styled(FormControlLabel)`
  && {
    color: #394760;

    span {
      font-weight: 700;
      font-size: 14px;
      line-height: 17.5px;
    }
  }
`;

export const RadioStylized = styled(Radio)`
  && {
    & svg.MuiSvgIcon-root {
      color: ${({ theme }) => theme.palette.grey._450.hex()};
    }

    & svg.MuiSvgIcon-root.PrivateRadioButtonIcon-layer-6 {
      color: ${({ theme }) => theme.palette.blue._400.hex()};
    }

    &.MuiRadio-colorSecondary.Mui-checked {
      & svg.MuiSvgIcon-root {
        color: ${({ theme }) => theme.palette.blue._400.hex()};
      }
    }

    svg {
      color: ${({ theme }) => theme.palette.blue._400.hex()} !important;
    }
  }
`;

export const StarSymbol = styled.p`
  color: ${({ theme }) => theme.palette.orange.main.hex()};
  padding-right: 8px;
`;

export const LabelContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
`;

export const Label = styled.h1`
  color: #394760;
  font-weight: 700;
  font-size: 14px;
  padding-bottom: 8px;
`;
